

import React from "react";
import PropTypes from "prop-types";
//export const LensDropDown=(props)=>{
      
class  LensDropDown extends React.Component{
  shouldComponentUpdate(nextProps, nextState) {
      
      if (this.props.selectedOption== nextProps.selectedOption && this.props.checked== nextProps.checked) {
        return false;
      } else {
        return true;
      }
    }
 

render(){
 
  const props=this.props;
return(<div className="form-group" key={props.indexVal}>
    <select className="form-control" value={props.selectedOption} onChange={props.callback} name={props.name} disabled={props.checked} >
               <option key={'ld-'} value="">{props.placeholder || "select"}</option>
              {props.listOptions.map((option,i) => (
                <option key={'l-'+i} value={option}>
                  {option}
                </option>
              ))}
            </select>
            </div>)
}

}

export default LensDropDown;